import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import VueTheMask from 'vue-the-mask'

import './css/global.css'

Vue.config.productionTip = false


Vue.use(VueTheMask)

new Vue({
  vuetify,
  router,
  store,
  
  render: h => h(App)
}).$mount('#app')
